import { DEFAULTS } from "@/react/story/data";
import type { Content } from "@/react/story/types";
import TemplatingUtils from "@/react/story/utils/TemplatingUtils";
import UploadUtils from "@/react/story/utils/UploadUtils";

type Props = {
    content: Content;
}

export default function ContentVideo(props: Props) {
    let src = props.content.config.src;
    if (props.content.config.video) {
        src = props.content.config.video?.uri;
    }

    const youtubeId = ("string" === typeof src ? UploadUtils.getYoutubeId(src) : null) ?? props.content.config.video?.youtubeId;
    if (youtubeId) {
        src = `https://www.youtube.com/embed/${youtubeId}`;
    }

    if ("string" !== typeof src) {
        return null;
    }

    return (
        <iframe
            style={{
                height: TemplatingUtils.percent(DEFAULTS.height),
                zIndex: 1000,
                ...TemplatingUtils.style(props.content.config, [ "maxWidth", "height" ]),
            }}
            src={src}
            frameBorder="0"
            allowFullScreen
        />
    );
}
